import template from './class-designer-home.html';
import controller from './class-designer-home.controller';
import './class-designer-home.scss';

export default {
	template,
	controller,
	bindings: {
		ctrl: '<',
		tab: '<',
	},
};
